<template lang="pug">
  div(:class="small ? 'w-50' : 'w-75'")
    b-table.rounded(:items="elements", :fields="fields", sticky-header="270px", striped, small)
      template(#head(title)="data")
        div {{table_title}}
        .small( v-if="subtitle") {{subtitle}}
</template>

<script>
export default {
  data () {
    return {
      fields: [{key: "title", thClass: 'bg-custom text-custom' }]
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    elements: {
      type: Array,
      default: function () {
        return []
      }
    },
    small : {
      type: Boolean,
      default: false
    }
  },
  computed: {
    table_title () {
      if(this.title) return this.title
      if(this.multiple) return "Selecciona una o más opciones"
      return "Selecciona una opción"
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
